"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _pclnDesignSystem = require("pcln-design-system");

var _LinkButton = _interopRequireDefault(require("../../navigation/LinkButton"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var StyledText = (0, _styledComponents["default"])(_pclnDesignSystem.Text).withConfig({
  componentId: "sc-1oxox65-0"
})(["color:", ";text-decoration:", ";white-space:", ";cursor:", ";text-decoration:", ";"], function (props) {
  return (0, _pclnDesignSystem.getPaletteColor)(props.subdued ? 'text.light' : 'base')(props);
}, function (props) {
  return props.strikethrough ? 'line-through' : 'none';
}, function (props) {
  return props.wrap ? 'normal' : 'nowrap';
}, function (props) {
  return props.onClick ? 'pointer' : 'inherit';
}, function (props) {
  return props.onClick ? 'underline' : 'nope';
});
var StyledLinkButton = (0, _styledComponents["default"])(_LinkButton["default"]).withConfig({
  componentId: "sc-1oxox65-1"
})(["margin-left:4px;"]);

function Typography(_ref) {
  var className = _ref.className,
      nativeTag = _ref.nativeTag,
      bold = _ref.bold,
      subdued = _ref.subdued,
      strikethrough = _ref.strikethrough,
      wrap = _ref.wrap,
      fontSize = _ref.fontSize,
      color = _ref.color,
      characterLimit = _ref.characterLimit,
      children = _ref.children,
      onClick = _ref.onClick,
      props = _objectWithoutProperties(_ref, ["className", "nativeTag", "bold", "subdued", "strikethrough", "wrap", "fontSize", "color", "characterLimit", "children", "onClick"]);

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      isShowing = _useState2[0],
      setShowing = _useState2[1];

  var onShowClick = function onShowClick() {
    return setShowing(true);
  };

  var shouldTruncate = characterLimit > 0 && children && children.length > characterLimit;
  var truncatedText = !isShowing && shouldTruncate ? "".concat(children.substring(0, characterLimit).trim(), "...") : children;
  return _react["default"].createElement(StyledText, _extends({
    className: className,
    as: nativeTag,
    bold: bold,
    subdued: subdued,
    strikethrough: strikethrough,
    wrap: wrap,
    fontSize: fontSize,
    color: color,
    onClick: onClick,
    m: 0
  }, props), truncatedText, !isShowing && shouldTruncate && _react["default"].createElement(StyledLinkButton, {
    fontSize: fontSize,
    onClick: onShowClick
  }, "Show more"));
}

Typography.displayName = 'Typography';
Typography.propTypes = {
  className: _propTypes["default"].string,
  nativeTag: _propTypes["default"].string,
  bold: _propTypes["default"].bool,
  subdued: _propTypes["default"].bool,
  strikethrough: _propTypes["default"].bool,
  wrap: _propTypes["default"].bool,
  fontSize: _propTypes["default"].number,
  color: _propTypes["default"].string,
  characterLimit: _propTypes["default"].number,
  children: _propTypes["default"].node,
  onClick: _propTypes["default"].func
};
Typography.defaultProps = {
  className: '',
  nativeTag: 'p',
  wrap: true,
  characterLimit: 0
};

var _default = (0, _react.memo)(Typography);

exports["default"] = _default;